/**
 * Lightbox Suport
 *
 * @see https://www.npmjs.com/package/basiclightbox
 * @see https://github.com/electerious/basicLightbox
 *
 * @since 1.0.0
 * @since 1.0.2 drops jQuery dependency and Colorbox
 */

import * as basicLightbox from 'basiclightbox';

/**
 * Generate the close <button> for basicLightBox
 *
 * @since 1.0.0
 *
 * @param {number} index	the current element's index
 */
export function getLightboxCloseButton(index) {
	const button = `<button id="lightbox-${index}" tabindex="1" class="basicLightbox__close no-button-style"><span class="screen-reader-text">Close</span><span class="dashicons dashicons-no-alt"></span></button>`;
	return button;
}

// get from localstorage (if the value expired it is destroyed)
/**
 * Retrieves a value from the local storage based on the provided key.
 * If the value exists and has not expired, it is returned. Otherwise, it is removed from the local storage.
 *
 * @param {string} key - The key used to retrieve the value from the local storage.
 * @returns {*} The retrieved value if it exists and has not expired, otherwise null.
 */
function localGet(key) {
	const stringValue = localStorage.getItem(key);
	if (stringValue !== null) {
		const value = JSON.parse(stringValue);
		const expirationDate = new Date(value.expirationDate);
		if (expirationDate > new Date()) {
			return value.value;
		}
		localStorage.removeItem(key);
	}
	return null;
}

/**
 * Sets a value in the local storage with an optional expiration time.
 *
 * @param {string} key - The key to set the value for.
 * @param {*} value - The value to be stored.
 * @param {number} [expirationInMin=43800] - The expiration time in minutes. Defaults to 43800 minutes (30 days).
 */
function localSet(key, value, expirationInMin = 43800) {
	const expirationDate = new Date(new Date().getTime() + (60000 * expirationInMin));
	const newValue = {
		value,
		expirationDate: expirationDate.toISOString(),
	};
	localStorage.setItem(key, JSON.stringify(newValue));
}

/**
 * Launches links to valid image formats into a lightbox instead of opening within window
 *
 * @see https://github.com/electerious/basicLightbox
 *
 * @since  1.0.1 Uses basicLightbox instead of Colorbox
 */
function initPopUpLightBox() {
	/**
	 * Query for anchor elements linking to supported image types.
	 */
	const lightboxEl = document.querySelectorAll('.site-disclaimer__modal-content');

	lightboxEl.forEach(

		(elem, index) => {
			/**
			 * Get the content from the lighbox div.
			 */
			const lbContent = elem.innerHTML;

			if (lbContent.length > 0) {
				/**
				 * Fetch the markup for the lightbox close button
				 */
				const lightboxCloseButton = getLightboxCloseButton(index);

				const html = basicLightbox.create(
					`${lightboxCloseButton}
					<div class="site-disclaimer__modal">
					${lbContent}
					</div>`, {
						className: 'site-popup__placeholder',
						closable: true,
					},
				);

				/**
				 * Launch the ligtbox on function init if cookie not expired.
				 */
				if (!localGet('hideModal')) {
					localSet('hideModal', 'expires', 43800);
					html.show();
				}

				const closeModalBtn = document.querySelector('#lightbox-0');
				closeModalBtn.addEventListener('click', () => html.close());
			}
		},
	);
}

/**
 * Run our lightbox functions once the DOM has been completely loaded.
 */
document.addEventListener('DOMContentLoaded', initPopUpLightBox);
